const CLASSES = {
  TRIGGER: 'scroll-trigger',
  OFFSCREEN: 'scroll-trigger--offscreen',
  ZOOM_IN: 'animate--zoom-in',
  CANCEL: 'scroll-trigger--cancel',
  DESIGN_MODE: 'scroll-trigger--design-mode',
};

/* ── Scroll-in animation ── */

function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const el = entry.target;

    if (entry.isIntersecting) {
      el.classList.remove(CLASSES.OFFSCREEN);
      if (el.hasAttribute('data-cascade')) {
        el.style.setProperty('--animation-order', index);
      }
      observer.unobserve(el);
    } else {
      el.classList.add(CLASSES.OFFSCREEN);
      el.classList.remove(CLASSES.CANCEL);
    }
  });
}

function initScrollAnimations(rootEl = document, isDesignMode = false) {
  const elements = Array.from(
    rootEl.getElementsByClassName(CLASSES.TRIGGER)
  );
  if (!elements.length) return;

  if (isDesignMode) {
    elements.forEach((el) => el.classList.add(CLASSES.DESIGN_MODE));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  elements.forEach((el) => observer.observe(el));
}

/* ── Zoom-in animation ── */

function percentageSeen(el) {
  const { innerHeight: vh, scrollY } = window;
  const top = el.getBoundingClientRect().top + scrollY;
  const height = el.offsetHeight;

  if (top > scrollY + vh) return 0;
  if (top + height < scrollY) return 100;

  return Math.round(
    (scrollY + vh - top) / ((vh + height) / 100)
  );
}

function initZoomAnimations() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const elements = Array.from(
    document.getElementsByClassName(CLASSES.ZOOM_IN)
  );
  if (!elements.length) return;

  const SCALE_AMOUNT = 0.002;

  elements.forEach((el) => {
    let isVisible = false;

    const observer = new IntersectionObserver(([entry]) => {
      isVisible = entry.isIntersecting;
    });
    observer.observe(el);

    const updateZoom = () => {
      el.style.setProperty(
        '--zoom-in-ratio',
        1 + SCALE_AMOUNT * percentageSeen(el)
      );
    };

    updateZoom();

    window.addEventListener('scroll', throttle(() => {
      if (isVisible) updateZoom();
    }), { passive: true });
  });
}

/* ── Init ── */

document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initZoomAnimations();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) =>
    initScrollAnimations(e.target, true)
  );
  document.addEventListener('shopify:section:reorder', () =>
    initScrollAnimations(document, true)
  );
}